// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";


import { environment } from './environments/environment';
import { authHttpInterceptorProvider, JwtAuthModule, AuthManagerService, User } from '@uzenith360/ngx-jwt-auth';
import { ErrorHandler/*, APP_INITIALIZER*/, importProvidersFrom, provideAppInitializer, inject } from '@angular/core';
// import { Router } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
// import { NgxErrorPagesModule } from '@uzenith360/ngx-error-pages';
// import { environment as environment_1 } from 'src/environments/environment';
import { AppComponent } from './app/app.component';
import { userType } from '@pixomaticc/ngx-ui';
import { TraceService } from '@sentry/angular';
import getCountryCode from "./app/get-country-code";

const userBaseUrl: string = environment.usersBaseUrl;
const tokenStoreId: string = 'iop';
const tryPINLogin: boolean = (() => {
    try {
        const { old_access_token, access_token } = JSON.parse(localStorage.getItem(tokenStoreId) ?? '{}');

        return !!AuthManagerService.jwtHelperService.decodeToken(
            old_access_token || access_token
        )?.['hashs'];
    } catch (e) {
        console.error(e);

        return false;
    }
})();



// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
// tracePropagationTargets: [
//   // environment.paymentsBaseUrl,
//   // environment.usersBaseUrl,
//   // environment.eventsBaseUrl,
//   // environment.photosBaseUrl,
//   // environment.notificationsBaseUrl,
// ],
// routingInstrumentation: Sentry.routingInstrumentation,

Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: environment.tracesSampleRate, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: environment.replaysSessionSampleRate, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: environment.replaysOnErrorSampleRate, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(AppRoutingModule/*, NgxNavigationAnimationModule*/, JwtAuthModule.forRoot({
            countryCode: getCountryCode(),
            authIdName: 'phone',
            forgotPasswordUrl: `${userBaseUrl}/photographers/init-verify-phone`,
            getLoggedinUserProfileUrl: `${userBaseUrl}/`,
            loginUrl: `${userBaseUrl}/photographers/login`,
            logoutUrl: `${userBaseUrl}/photographers/logout`,
            pinLoginUrl: `${userBaseUrl}/photographers/login-pin`,
            resetPasswordUrl: `${userBaseUrl}/photographers/reset-password`,
            superAdminPages: [],
            interceptorSkipUrls: [
                `${userBaseUrl}/photographers/init-verify-phone`,
                `${userBaseUrl}/photographers/reset-password`,
                // for register route, they dont need to be logged in to call this endpoint
                `${userBaseUrl}/photographers`,
            ],
            tokenStoreId,
            tryPINLogin,
            // pass in a function that gets the result of a dialog auth guard login event
            onAuthGuardLoginUser(user: User) {
                if (!user['hashs']) {
                    try {
                        !localStorage.getItem(AppComponent.hasPinStoreId)
                            && AppComponent.onAuthGuardLoginUserSubject.next();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                Sentry.withScope(function (scope) {
                    scope.setTag("isDialogLogin", true);
                    scope.setUser({
                        email: user.email,
                        id: (user as unknown as {
                            userId: string;
                        })['userId'],
                        username: user.firstName,
                        phone: user.phone,
                        segment: userType.photographer,
                    });
                });
            },
        })),
        authHttpInterceptorProvider,
        // { provide: ErrorHandler, useClass: MyErrorHandler },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                // showDialog: true,
            }),
        },
        // {
        //     provide: Sentry.TraceService,
        //     deps: [Router],
        // },
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: () => () => { },
        //     deps: [Sentry.TraceService],
        //     multi: true,
        // },
        provideAppInitializer(async () => inject(TraceService)),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        // Provide the Material date adapter once at the application root so dialog
        // components don't need component-level date providers. Component-level
        // providers create an injector boundary that breaks MatDialogRef resolution
        // when such a dialog is opened nested inside another dialog (NG0201).
        provideNativeDateAdapter(),
    ]
})
    .then((success) => {
        console.log('Bootstrap success');

        // // remove HTTP refresh tag on success to prevent refresh
        // const refreshMetaHeader: Element = document.head.querySelector('meta[http-equiv="refresh"]')!;

        // refreshMetaHeader.parentNode?.removeChild(refreshMetaHeader) && console.log('Stopped refresh watchdog');
    }).catch((err) => {
        window.location.reload();

        console.error(err);
    });
